export default "__VITE_ASSET__DXFt2p$k__"